<!-- <p>user-location-permission-dialog works!</p> -->
<h1 mat-dialog-title>Enable Location</h1>
<div mat-dialog-content>
  <p>
    Location access is required to use this feature. Please enable location
    services.
  </p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button (click)="onYesClick()">Open Settings</button>
</div>
